import styled, { css } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const HeaderAndChipsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const HeaderName = styled(Text)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`

export const HeaderDate = styled(Text)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`

export const ChipsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const MethodsAndChipsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const MethodsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const MethodContainer = styled.div`
  background-color: ${props => props.theme.colors.warning.surface};
  color: ${props => props.theme.colors.warning.onSurface};
  border-radius: ${props => props.theme.primitives.radius.radius6};
  height: ${props => props.theme.size.S};
  width: ${props => props.theme.size.S};
  display: flex;
  justify-content: center;
  align-items: center;

  svg path {
    fill: currentColor;
  }

  ${props =>
    props.isDisabled &&
    css`
      background-color: ${props => props.theme.colors.disabled.surface};
      color: ${props => props.theme.colors.text.subtle};
    `}
`
